import { MessageCircle } from "lucide-react";

// Live business contact
const WHATSAPP_NUMBER = "918055592955"; // +91 80555 92955
const WHATSAPP_DISPLAY = "Yadav Bawane";
const WHATSAPP_TEXT = encodeURIComponent(
  `Hi ${WHATSAPP_DISPLAY}, I'd like to know more about UID Infotech's services.`
);

export default function WhatsAppFloat() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Chat with ${WHATSAPP_DISPLAY} on WhatsApp`}
      title={`Chat with ${WHATSAPP_DISPLAY} on WhatsApp`}
      data-testid="whatsapp-float"
      className="wa-pulse fixed bottom-6 right-6 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-10px_rgba(37,211,102,0.7)] hover:scale-110 transition-transform"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
